import ResponsivePageLayout from './ResponsivePageLayout';

export default ResponsivePageLayout;
